import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ArrowRight } from 'phosphor-react';
import { Link } from 'react-router-dom';
import { useAuthWrapper } from '_helpers';
import { Bezel, Button, Input, Eyebrow } from '_ui';

export function Login() {
    const auth = useAuthWrapper();
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm();

    async function onSubmit(values) {
        setLoading(true);
        await auth.login(values);
        setLoading(false);
    }

    return (
        <div className="grid min-h-[100dvh] md:grid-cols-2">
            {/* Left — editorial statement */}
            <div className="relative flex flex-col justify-between overflow-hidden bg-gradient-to-br from-sand-200 via-cream-100 to-cream px-8 py-12 md:px-14 md:py-16">
                <a href="/" className="flex items-center gap-3 no-underline">
                    <img src="/logo-badge.png" alt="Sunny Nail" className="h-11 w-11 rounded-full bg-cream-50/90 object-contain p-0.5" />
                    <div className="leading-none">
                        <span className="font-serif text-xl text-espresso">Sunny Nail</span>
                        <span className="mt-1 block text-[9px] uppercase tracking-eyebrow text-brass">Quản lý tiệm</span>
                    </div>
                </a>
                <div className="max-w-md">
                    <Eyebrow className="mb-6">Hệ thống hoa hồng &amp; lương</Eyebrow>
                    <h1 className="font-serif text-5xl leading-[1.05] text-espresso md:text-6xl">
                        Mỗi dịch vụ, <span className="italic text-brass-deep">đúng hoa hồng.</span>
                    </h1>
                    <p className="mt-6 text-lg leading-relaxed text-espresso-soft">
                        Ghi nhận giao dịch, xác nhận thanh toán qua chuyển khoản và tiền mặt, và tính lương minh bạch cho từng nhân viên.
                    </p>
                </div>
                <p className="text-sm text-espresso-soft/60">© {new Date().getFullYear()} Sunny Nail</p>
            </div>

            {/* Right — sign-in card */}
            <div className="flex items-center justify-center px-6 py-12 md:px-12">
                <div className="w-full max-w-md">
                    <Bezel className="px-8 py-10">
                        <Eyebrow className="mb-5">Đăng nhập</Eyebrow>
                        <h2 className="font-serif text-3xl text-espresso">Chào mừng trở lại</h2>
                        <p className="mt-2 text-sm text-espresso-soft/80">Dùng email và mật khẩu được cấp.</p>

                        <form onSubmit={handleSubmit(onSubmit)} className="mt-8 space-y-5">
                            <Input
                                label="Email"
                                type="email"
                                placeholder="ban@sunnynail.io.vn"
                                autoComplete="username"
                                error={errors.email && 'Vui lòng nhập email'}
                                {...register('email', { required: true })}
                            />
                            <Input
                                label="Mật khẩu"
                                type="password"
                                placeholder="••••••••"
                                autoComplete="current-password"
                                error={errors.password && 'Vui lòng nhập mật khẩu'}
                                {...register('password', { required: true })}
                            />
                            <Button type="submit" icon={ArrowRight} loading={loading} className="w-full justify-between" size="lg">
                                {loading ? 'Đang đăng nhập…' : 'Đăng nhập'}
                            </Button>
                            <Link to="/account/forgot-password" className="block text-center text-sm text-espresso-soft/70 hover:underline">
                                Quên mật khẩu?
                            </Link>
                        </form>
                    </Bezel>
                </div>
            </div>
        </div>
    );
}
